import {Component, Input, OnInit} from '@angular/core';
import {FontAwesomeService} from "@services/font-awesome.service";

@Component({
  selector: 'app-card-wrapper',
  template: `
    <div class="card-container" [ngClass]="{'active': active, 'full-height': fullHeight}">
      <ng-container *ngIf="!removePanel">
        <div *ngIf="leftPanel; else topPannel" class="left-panel" [ngClass]="{'failure': failure}"></div>
        <ng-template #topPannel>
          <div class="top-panel {{topPanelClass}}"></div>
        </ng-template>
      </ng-container>

      <ng-content></ng-content>
      <div *ngIf="active" class="active-container">
        <fa-icon [icon]="faService.faCheckCircle"></fa-icon>
      </div>
      <!--<ng-content select=".title"></ng-content>-->
      <!--<ng-content select=".clear-sign"></ng-content>-->
      <!--<ng-content select=".content"></ng-content>-->
      <!--<ng-content select=".bottom-signs"></ng-content>-->

    </div>
  `,
  styleUrls: ['./card-wrapper.component.scss']
})
export class CardWrapperComponent implements OnInit {
  @Input() fullHeight: boolean;
  @Input() leftPanel: boolean;
  @Input() removePanel: boolean;
  @Input() active: boolean;
  @Input() failure: boolean;
  @Input() topPanelClass: string;

  constructor(public faService: FontAwesomeService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/components/card-wrapper/card-wrapper.component.ts